import { Component, input, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IItemBudget } from '@core/interface';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-ui-budget-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './budget-item.component.html',
  styleUrls: ['./budget-item.component.scss'],
})
export class BudgetItemComponent {
  item = input.required<IItemBudget>();
  isLast = input<boolean>(false);
}
